import React, { useEffect, useState, useRef } from "react";
import {
  getAllDepartments,
  getAllAppoints,
  getAllDesignations,
} from "../../../../../api/onboarddeboard";

const inputStyle = {
  border: "1.5px solid #e2e8f0",
  borderRadius: 8,
  padding: "10px 14px",
  fontSize: 14,
  color: "#1a202c",
  background: "#f8fafc",
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
  fontFamily: "inherit",
  appearance: "auto",
  cursor: "pointer",
};

const labelStyle = {
  fontWeight: 600,
  fontSize: 13,
  color: "#374151",
  marginBottom: 6,
  display: "block",
};

const errorStyle = { color: "#dc3545", fontSize: 12, marginTop: 4 };

const ServiceDetails = ({
  employeeData,
  setEmployeeData,
  onSubmit,
  errors = {},
  setErrors,
 isSubmitting,
  touchedFields = {},
  setTouchedFields,
  isEditMode = false,
}) => {
  const token = localStorage.getItem("token");
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [appoints, setAppoints] = useState([]);
  const joiningRef = useRef(null);

  // Active/Inactive toggle — read from serviceDetails.status, default active
  const isActive = employeeData.serviceDetails?.status !== "inactive";

  // Relieving-date confirmation popup — shown only when switching Active → Inactive
  const [showRelievingModal, setShowRelievingModal] = useState(false);
  const [relievingDate, setRelievingDate] = useState(
    employeeData.serviceDetails?.dateOfReleaving || ""
  );
  const [relievingDateError, setRelievingDateError] = useState("");

  useEffect(() => {
    getAllDepartments(token).then((res) =>
      setDepartments(res.data.map((d) => ({ id: d.id, name: d.departmentName })))
    );
    getAllDesignations(token).then((res) =>
      setDesignations(res.data.map((d) => ({ id: d.id, name: d.designationName })))
    );
    getAllAppoints(token).then((res) =>
      setAppoints(res.data.map((a) => ({ id: a.id, name: a.appointName })))
    );
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData((prev) => ({
      ...prev,
      serviceDetails: { ...prev.serviceDetails, [name]: value },
    }));
    if (value) setErrors((prev) => ({ ...prev, [name]: "" }));
  };
const toggleStatus = () => {
    if (!isEditMode) {
      return;
    }
    if (!isActive) {
      // Employee is already Inactive — this is a one-way transition.
      // The toggle is locked and cannot be switched back to Active.
      return;
    }
    // Switching Active → Inactive: show the confirmation popup first,
    // don't change status yet.
    setRelievingDate(employeeData.serviceDetails?.dateOfReleaving || "");
    setRelievingDateError("");
    setShowRelievingModal(true);
  };

  const handleConfirmRelieving = () => {
    if (!relievingDate) {
      setRelievingDateError("Relieving date is required");
      return;
    }
    setEmployeeData((prev) => ({
      ...prev,
      serviceDetails: {
        ...prev.serviceDetails,
        status: "inactive",
        dateOfReleaving: relievingDate,
      },
    }));
    setShowRelievingModal(false);
  };

  const handleCancelRelieving = () => {
    setShowRelievingModal(false);
    setRelievingDateError("");
  };

  return (
    <>
      {/* ROW 1 — Employee ID | Department */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
        <div>
  <label style={labelStyle}>Employee ID <span style={{ color: "#dc3545" }}>*</span></label>
  <input
    type="text"
    name="employeeId"
    placeholder="Enter employee id"
    value={employeeData.serviceDetails?.employeeId || employeeData.personalDetails?.employeeId || ""}
   onChange={(e) => {
      const { value } = e.target;
      setEmployeeData((prev) => ({
        ...prev,
        serviceDetails: { ...prev.serviceDetails, employeeId: value },
        personalDetails: { ...prev.personalDetails, employeeId: value },
      }));
      const t = value.trim();
      if (value === "") {
        setErrors((prev) => ({ ...prev, employeeId: "Employee ID is required" }));
      } else if (t === "") {
        setErrors((prev) => ({ ...prev, employeeId: "Employee ID cannot contain only spaces" }));
      } else if (/^[^a-zA-Z0-9]+$/.test(t)) {
        setErrors((prev) => ({ ...prev, employeeId: "Employee ID cannot contain only special characters" }));
      } else if (/\s/.test(t)) {
        setErrors((prev) => ({ ...prev, employeeId: "Employee ID cannot contain spaces" }));
      } else {
        setErrors((prev) => ({ ...prev, employeeId: "" }));
      }
    }}
    style={{ ...inputStyle, borderColor: errors.employeeId ? "#dc3545" : "#e2e8f0" }}
  />
  {errors.employeeId && <div style={errorStyle}>{errors.employeeId}</div>}
</div>
        <div>
          <label style={labelStyle}>Department <span style={{ color: "#dc3545" }}>*</span></label>
          <select
            name="departmentId"
            value={employeeData.serviceDetails?.departmentId || ""}
            onChange={handleChange}
            style={{ ...inputStyle, borderColor: errors.departmentId ? "#dc3545" : "#e2e8f0" }}
          >
            <option value="">Select department</option>
            {departments.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          {errors.departmentId && <div style={errorStyle}>{errors.departmentId}</div>}
        </div>
      </div>

      {/* ROW 2 — Designation | Employment Type */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
        <div>
          <label style={labelStyle}>Designation <span style={{ color: "#dc3545" }}>*</span></label>
          <select
            name="designationId"
            value={employeeData.serviceDetails?.designationId || ""}
            onChange={handleChange}
            style={{ ...inputStyle, borderColor: errors.designationId ? "#dc3545" : "#e2e8f0" }}
          >
            <option value="">Select designation</option>
            {designations.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          {errors.designationId && <div style={errorStyle}>{errors.designationId}</div>}
        </div>
        <div>
          <label style={labelStyle}>Employment Type <span style={{ color: "#dc3545" }}>*</span></label>
          <select
            name="appointId"
            value={employeeData.serviceDetails?.appointId || ""}
            onChange={handleChange}
            style={{ ...inputStyle, borderColor: errors.appointId ? "#dc3545" : "#e2e8f0" }}
          >
            <option value="">Select type</option>
            {appoints.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          {errors.appointId && <div style={errorStyle}>{errors.appointId}</div>}
        </div>
      </div>

      {/* ROW 3 — Joining Date | Appointment */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
        <div>
          <label style={labelStyle}>Joining Date <span style={{ color: "#dc3545" }}>*</span></label>
          <input
            type="date"
            ref={joiningRef}
            name="dateOfJoining"
            value={employeeData.serviceDetails?.dateOfJoining || ""}
            onChange={handleChange}
            onClick={() => joiningRef.current?.showPicker()}
            style={{ ...inputStyle, borderColor: errors.dateOfJoining ? "#dc3545" : "#e2e8f0" }}
          />
          {errors.dateOfJoining && <div style={errorStyle}>{errors.dateOfJoining}</div>}
        </div>
        <div>
          <label style={labelStyle}>Appointment</label>
          <select
            name="appointId"
            value={employeeData.serviceDetails?.appointId || ""}
            onChange={handleChange}
            style={{ ...inputStyle, borderColor: "#e2e8f0" }}
          >
            <option value="">Select appointment</option>
            {appoints.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        </div>
      </div>

      {/* ROW 4 — Status toggle (Enable / Disable) */}
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>Status</label>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          {/* Toggle switch */}
          <div
           onClick={toggleStatus}
            title={!isEditMode ? "New employees are created as Active" : !isActive ? "Inactive employees cannot be reactivated" : ""}
            style={{
              width: 48,
              height: 26,
              borderRadius: 13,
              background: isActive ? "#3b5fc0" : "#d1d5db",
              position: "relative",
cursor: isEditMode && isActive ? "pointer" : "not-allowed",
              transition: "background 0.25s",
              flexShrink: 0,
              opacity: isActive ? 1 : 0.7,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 3,
                left: isActive ? 24 : 3,
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                transition: "left 0.25s",
              }}
            />
          </div>
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: isActive ? "#16a34a" : "#6b7280",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        </div>
      </div>

      {/* Relieving Date confirmation popup — shown when marking employee Inactive */}
      {showRelievingModal && (
        <div
          onClick={handleCancelRelieving}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
            zIndex: 1400, display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff", borderRadius: 12, width: 380,
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)", overflow: "hidden",
            }}
          >
            <div style={{ padding: "18px 20px 14px", borderBottom: "1px solid #f0f0f0" }}>
              <span style={{ fontWeight: 700, fontSize: 15, color: "#111827" }}>
                Mark Employee Inactive
              </span>
            </div>

            <div style={{ padding: "18px 20px" }}>
              <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 16px" }}>
                Are you sure you want to mark this employee as Inactive? This action cannot be undone.
              </p>

              <label style={labelStyle}>
                Relieving Date <span style={{ color: "#dc3545" }}>*</span>
              </label>
              <input
                type="date"
                value={relievingDate}
                onChange={(e) => {
                  setRelievingDate(e.target.value);
                  if (e.target.value) setRelievingDateError("");
                }}
                style={{ ...inputStyle, borderColor: relievingDateError ? "#dc3545" : "#e2e8f0" }}
              />
              {relievingDateError && <div style={errorStyle}>{relievingDateError}</div>}
            </div>

            <div style={{
              display: "flex", justifyContent: "flex-end", gap: 10,
              padding: "14px 20px", borderTop: "1px solid #f0f0f0",
            }}>
              <button
                type="button"
                onClick={handleCancelRelieving}
                style={{
                  padding: "7px 20px", border: "1px solid #d1d5db",
                  borderRadius: 6, background: "#fff", color: "#374151",
                  fontSize: 13, fontWeight: 500, cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirmRelieving}
                style={{
                  padding: "7px 20px", border: "none",
                  borderRadius: 6, background: "#3b5fc0", color: "#fff",
                  fontSize: 13, fontWeight: 600, cursor: "pointer",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServiceDetails;
